/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from 'react';
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {FONTS} from "@res/fonts";
import {
	Spacing
} from "@styles/styles";
import { VGap } from '../../widget/VGap';
import { no_data } from '../patients/PatientTab';

type Props = {
	label?: string
}

export class NoData
	extends BaseComponent<Props> {

	constructor(props: Props) {
		super(props);
	}

	render() {
		return <div className={'ll_v_s'} style={{flex: 1, margin: Spacing.l, alignSelf: 'center', justifyContent: 'center', alignItems: 'center'}}>
			<img src={no_data} height={100} width={150}/>
			<VGap v={Spacing.m} />
			{FONTS.reg_14_secondary_dark(this.props.label || 'no data', {textAlign: 'center'})}
		</div>;
	}
}
